import './index.css'
import { useState, useEffect } from "react";
import {
    InputLabel,
    FormGroup,
    Paper,
    TextField,
    Typography,
    FormControl,
    Button,
    MenuItem,
    Select,
    FormControlLabel,
    Checkbox,
    RadioGroup,
    Radio,
    Drawer,
    Table,
    TableRow,
    TableCell,
    TableHead,
    LinearProgress,
    FormHelperText,
    ListSubheader
  } from "@material-ui/core";
  import { makeStyles } from "@material-ui/core/styles";

  const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    smallbutton: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      height: theme.spacing(4),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    formgroup: {
      justifyContent: "center",
    },
    textArea: {
      marginLeft: theme.spacing(12),
      marginRight: theme.spacing(14),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textArea2: {
      marginLeft: theme.spacing(4),
      width: theme.spacing(168),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(24),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    smallbutton2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(10),
      height: theme.spacing(4),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headtext: {
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      
    },
   
    redheadtext: {
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
      justifyContent:"center",
      border: "red solid 2px"
    },
    bodytext: {
      marginLeft: theme.spacing(5),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    bodytext2: {
      marginLeft: theme.spacing(5),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      backgroundColor: "#f94449",
    },
  }));

const MyModal=({data})=>{
    var cm1=data.cm
    var cm2=data.cm2
    var cm3=data.cm3
    var colors = ['#d6e9f7', '#f2e5fd', '#f8dbec', '#ecf4da', '#f7edde', '#ffd9d6', '#faf8de', '#defaf9', '#e0fff4', '#afc6ff'];
    var random_color = colors[Math.floor(Math.random() * colors.length)];
    const [conf1, setconf1] = useState("");
    const [conf2, setconf2] = useState("");
    const classes = useStyles();

 
    //$('#title').css('background-color', random_color)
    // console.log(cm1, cm2)

    return(
        <div className="container">
        <div className="box">
        <div  id="title" style={{ backgroundColor: random_color,
        height:"100%",
        width:"100%",
        // // text-align: center,
        // // align-items: center,
        // marginleft:"20vw",
      }}>
            <p className="text2">{cm2}</p>
            <br></br>
            {/* <button className="buttontext" onClick={cm1}>Close</button>
            <button className="buttontext" onClick={()=>cm3(true)}>Proceed</button> */}
            <p className="text">Press "No" to go back and make changes and press "Yes" to proceed without any changes.</p>
            {cm2=="Flight prices seem unreasonable. Kindly consult your TL"?(
                <div>
                <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="conf1">
                  Did you check flights from alternate airports?
                </InputLabel>
                <Select
                  classname={classes.textField}
                  labelId="conf1"
                  value={conf1}
                  onChange={(e) =>
                    setconf1(e.target.value)
                  }
                >
                  <MenuItem value={"Yes"}>Yes</MenuItem>
                  <MenuItem value={"No"}>No</MenuItem>
                
                </Select>
              </FormControl>
              <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="conf2">
                  Did you check flights on alternate dates?
                </InputLabel>
                <Select
                  classname={classes.textField}
                  labelId="conf2"
                  value={conf2}
                  onChange={(e) =>
                    setconf2(e.target.value)
                  }
                >
                  <MenuItem value={"Yes"}>Yes</MenuItem>
                  <MenuItem value={"No"}>No</MenuItem>
                
                </Select>
              </FormControl>
              <br></br>
              <br></br>
              {conf1=="Yes" && conf2=="Yes"?(<div>
                <button className="buttontext" onClick={cm1}>Yes</button>
                <button className="buttontext" onClick={cm3}>No</button>
            </div>):("")}
                </div>
            ):(<div>
                <button className="buttontext" onClick={cm1}>Yes</button>
                <button className="buttontext" onClick={cm3}>No</button>
            </div>)}
            </div>
            </div>
        </div>
    )
}

export default MyModal